import * as ActionTypes from './actionTypes';
import {wpQuery} from 'polyphony/networking';
import {uuidv4} from 'polyphony/util';
import {splitURL} from 'polyphony/dom';

export const setState = state => ({ type: ActionTypes.SET_STATE, state });

export const loadContentStarted = (queryPath, extraQueryVars, replace, requestId) => ({ type: ActionTypes.LOAD_CONTENT_STARTED, queryPath, extraQueryVars, replace, requestId });
export const loadContentFinished = (json, requestId, error = null) => ({ type: ActionTypes.LOAD_CONTENT_FINISHED, json, error, requestId });

export const loadMoreContentStarted = (requestId) => ({ type: ActionTypes.LOAD_MORE_CONTENT_STARTED, requestId });
export const loadMoreContentFinished = (json, requestId, error = null) => ({ type: ActionTypes.LOAD_MORE_CONTENT_FINISHED, json, error, requestId});

export const loadContent = function(path = null, xsArgs = {}, replace = false) {
    return dispatch => {
        let p = path ? path : splitURL().rootRelative;
        let requestId = uuidv4();
        dispatch(loadContentStarted(p, xsArgs, replace, requestId));
        return wpQuery(p, xsArgs).then(json => dispatch(loadContentFinished(json, requestId)));
    };
};

export const loadMoreContent = () => {
    return (dispatch, getState) => {
        let requestId = uuidv4();
        dispatch(loadMoreContentStarted(requestId));
        const {is, terms, posts, total_count, queryPath, extraQueryVars} = getState();
        if ((terms && terms.length < total_count) || (posts && posts.length < total_count)) { // eslint-disable-line
            let path = queryPath ? queryPath : getBrowserPath();
            let offset = (is.terms ? terms : posts).length;
            return wpQuery(path, {...extraQueryVars, offset, ignore_sticky_posts: 'true'}).then(json => dispatch(loadMoreContentFinished(json, requestId)));
        }
        return Promise.resolve(null);
    };
};

export const setContentWrapper = contentWrapper => ({ type: ActionTypes.SET_CONTENT_WRAPPER, contentWrapper});

export const addBlock = block => ({type:ActionTypes.ADD_BLOCK, block});
export const setErrorPage = component => ({type:ActionTypes.REGISTER_ERROR_PAGE, component});
export const setNotFoundPage = component => ({type:ActionTypes.REGISTER_NOT_FOUND_PAGE, component});
export const setLoadingIndicator = component => ({type:ActionTypes.REGISTER_LOADING_INDICATOR, component});
export const registerPostType = (post_type, Post, Archive) => ({type:ActionTypes.REGISTER_POST_TYPE, post_type, Post, Archive});
export const registerTaxonomy = (taxonomy, Archive) => ({type:ActionTypes.REGISTER_TAXONOMY, Archive, taxonomy});

export const registerCustomizerControl = (key, Component) => ({type:ActionTypes.REGISTER_CUSTOMIZER_CONTROL, key, Component});

export const setHashScrollOffset = (offset) => ({type:ActionTypes.SET_HASH_SCROLL_OFFSET, offset});

export const setFocusMode = focusMode => ({type:ActionTypes.SET_FOCUS_MODE, focusMode});

export const setWindowSize = (width, height) => ({type: ActionTypes.SET_WINDOW_SIZE, width, height});
export const setWindowPosition = (x, y) => ({type: ActionTypes.SET_WINDOW_POSITION, x, y});

